import type { FooterLink } from './types';

export const channelLinks: FooterLink[] = [
  {
    label: 'SouJunior Labs',
    to: 'https://docs.google.com/forms/d/e/1FAIpQLSd1IspO3Hwylce2kHtIsmyBAkH7p3VFmdYUmdL75YXZ-DSNBA/viewform',
  },
  { label: 'SouJunior Talks', to: 'https://discord.gg/64sXAewKEC' },
  { label: 'Blog da SouJunior', to: 'https://blog.soujunior.tech/' },
];
